import { LogLevel } from '@azure/msal-browser';

/**
 * Variables from environment at build time
 */
const rawBaseUrl = process.env.REACT_APP_API_GATEWAY_URL || '';
const rawBasePath = process.env.REACT_APP_BASE_PATH || '';
export const Environment = process.env.REACT_APP_ENVIRONMENT || 'test';

/**
 * INTERIM code override — non-prod routes to the Umbraco CMS adapter.
 *
 * This forces the adapter without an AzDO variable-group change (we don't
 * yet have Administrator on AppNonProd). Once REACT_APP_API_GATEWAY_URL is
 * repointed at the adapter in the variable group, delete this block and use:
 *     export const BaseUrl = rawBaseUrl;
 *     export const BasePath = rawBasePath;
 *
 * Two guards keep it scoped:
 *   - Environment !== 'production' ensures prod is never affected.
 *   - the non-prod host check excludes local dev (gateway = localhost),
 *     which keeps talking to its locally-running CMSAdapter via rawBaseUrl.
 */
const routeToAdapter =
  Environment !== 'production' &&
  rawBaseUrl.includes('nonprod.itm.co.nz');

export const BaseUrl = routeToAdapter
  ? 'https://itm-aue-nprod-cmsadapter-flex-func.azurewebsites.net'
  : rawBaseUrl;
export const BasePath = routeToAdapter ? '' : rawBasePath;
export const GoogleApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

/**
 * Build a request URL for a given relative path
 * 
 * @param {string} path 
 * @returns 
 */
export function buildRequestUrl(path) {
    return `${BaseUrl}${BasePath}${path}`;
}

/**
 * Microsoft B2C Policies
 */
const B2CDomain = process.env.REACT_APP_B2C_DOMAIN;
const B2CBasePath = process.env.REACT_APP_B2C_BASE_PATH;

const B2CNames = {
    signUpSignIn: process.env.REACT_APP_B2C_SIGNIN_PROFILE,
    forgotPassword: process.env.REACT_APP_B2C_FORGOT_PROFILE,
    editProfile: process.env.REACT_APP_B2C_EDIT_PROFILE
};

export const B2CPolicies = {
    names: B2CNames,
    authorities: {
        signUpSignIn: {
            authority: `https://${B2CDomain}${B2CBasePath}/${B2CNames.signUpSignIn}`
        },
        forgotPassword: {
            authority: `https://${B2CDomain}${B2CBasePath}/${B2CNames.forgotPassword}`
        },
        editProfile: {
            authority: `https://${B2CDomain}${B2CBasePath}/${B2CNames.editProfile}`
        },
    },
    authorityDomain: B2CDomain,
};

/**
 * Microsoft B2C Config
 */
export const MsalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENT_ID, 
        authority: B2CPolicies.authorities.signUpSignIn.authority, 
        knownAuthorities: [B2CPolicies.authorityDomain],
        redirectUri: '/login',
        postLogoutRedirectUri: '/logged-out', 
        navigateToLoginRequestUrl: false, 
    },
    telemetry: {
        application: {
            appName: 'ITM Application'
        }
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const B2CScopes = ['openid'];